import { ReactComponent as Arrow } from './components/arrow.svg';
import { ReactComponent as ArrowDown } from './components/arrow-down.svg';
import { ReactComponent as Binance } from './components/binance.svg';
import { ReactComponent as CanadaFlag } from './components/canada-flag.svg';
import { ReactComponent as Colon } from './components/colon.svg';
import { ReactComponent as Copy } from './components/copy.svg';
import { ReactComponent as Cross } from './components/cross.svg';
import { ReactComponent as Discord } from './components/discord.svg';
import { ReactComponent as Ethereum } from './components/ethereum.svg';
import { ReactComponent as Exit } from './components/exit.svg';
import { ReactComponent as Facebook } from './components/facebook.svg';
import { ReactComponent as Gift } from './components/gift.svg';
import { ReactComponent as Instagram } from './components/instagram.svg';
import { ReactComponent as Loader } from './components/loader.svg';
import { ReactComponent as Logo } from './components/logo.svg';
import { ReactComponent as LogoSmall } from './components/logo-small.svg';
import { ReactComponent as Metamask } from './components/metamask.svg';
import { ReactComponent as Question } from './components/question.svg';
import { ReactComponent as QuestionFill } from './components/question-fill.svg';
import { ReactComponent as Radio } from './components/radio.svg';
import { ReactComponent as RadioChecked } from './components/radio-checked.svg';
import { ReactComponent as Reddit } from './components/reddit.svg';
import { ReactComponent as Star } from './components/star.svg';
import { ReactComponent as Telegram } from './components/telegram.svg';
import { ReactComponent as Twitter } from './components/twitter.svg';
import { ReactComponent as UsaFlag } from './components/usa-flag.svg';
import { ReactComponent as Walletconnect } from './components/walletconnect.svg';
import { ReactComponent as Tether } from './components/tether.svg';

export default {
  'arrow-down': ArrowDown,
  arrow: Arrow,
  cross: Cross,
  discord: Discord,
  telegram: Telegram,
  twitter: Twitter,
  facebook: Facebook,
  gift: Gift,
  instagram: Instagram,
  question: Question,
  'question-fill': QuestionFill,
  reddit: Reddit,
  radio: Radio,
  'radio-checked': RadioChecked,
  logo: Logo,
  logoSmall: LogoSmall,
  metamask: Metamask,
  walletconnect: Walletconnect,
  copy: Copy,
  exit: Exit,
  'usa-flag': UsaFlag,
  'canada-flag': CanadaFlag,
  star: Star,
  colon: Colon,
  loader: Loader,
  Ethereum,
  'BNB Chain': Binance,
  'Binance Smart Chain': Binance,
  ETH: Ethereum,
  BNB: Binance,
  USDT: Tether,
};
